// Reports (HRTH-94): what the reasons mean, and how a report's state reads.
import type { ModerationKind, Report, ReportReason, ReportStatus } from '../api/types'

export const REASONS: { reason: ReportReason; label: string; hint: string }[] = [
  { reason: 'harassment', label: 'Harassment', hint: 'Bullying, threats or abuse' },
  { reason: 'spam', label: 'Spam', hint: 'Unwanted ads, scams or flooding' },
  { reason: 'illegal_content', label: 'Illegal content', hint: 'Something against the law' },
  { reason: 'child_safety', label: 'Child safety', hint: 'Sexual content involving minors, or a child at risk (handled first)' },
  { reason: 'copyright', label: 'Copyright', hint: 'Shared without the rights holder’s permission' },
  { reason: 'other', label: 'Other', hint: 'Anything else moderators should look at' },
]

export const reasonLabel = (r: ReportReason) => REASONS.find((x) => x.reason === r)?.label ?? r

export const STATUS_LABEL: Record<ReportStatus, string> = { open: 'Open', in_review: 'In review', resolved: 'Resolved' }

const ACTION_VERB: Record<ModerationKind, string> = { hide: 'hid the message', suspend: 'suspended them', remove: 'removed them from the space' }

/** "Carol hid the message", "Carol suspended them for 1 day". */
export function describeAction(a: NonNullable<Report['action']>, name: (u: string) => string): string {
  const len = a.minutes ? ` for ${a.minutes >= 1440 ? `${Math.round(a.minutes / 1440)} days` : a.minutes >= 60 ? `${Math.round(a.minutes / 60)} h` : `${a.minutes} min`}` : ''
  return `${name(a.by)} ${ACTION_VERB[a.kind]}${len}`
}
